import {
  EMPTY_STRING,
  IS_ERROR,
  IS_RECORDING,
  PLAY_RECORDING,
  RECORDING_STATUS,
  TAP_TO_START,
} from '../../constants/constants';

/**
 * Gets the title by status.
 * @param {string} status - The status.
 * @return {string} title - The title.
 * */
export const getTitle = (status) => {
  let title = EMPTY_STRING;

  switch (status) {
    case RECORDING_STATUS.WAITING:
      title = TAP_TO_START;
      break;
    case RECORDING_STATUS.RECORDING:
      title = IS_RECORDING;
      break;
    case RECORDING_STATUS.ERROR:
      title = IS_ERROR;
      break;
    case RECORDING_STATUS.RECORDED:
    case RECORDING_STATUS.PLAYING:
      title = PLAY_RECORDING;
      break;
    default:
      title = EMPTY_STRING;
  }

  return title;
};

export const ifGetErrorStatus = (status) => {
  let errorStatus = false;
  switch (status) {
    case RECORDING_STATUS.ERROR:
      errorStatus = true;
      break;
    default:
      errorStatus = false;
  }
  return errorStatus;
}

/**
 * Pads the value.
 * @param {number} value - The value.
 * @return {string} paddedValue - The padded value.
 * */
export const pad = (value) => {
  const string = value.toString();

  return string.length < 2 ? `0${string}` : string;
};

/**
 * Formats the duration.
 * @param {number} duration - The value.
 * @return {string} formattedDuration - The formatted duration.
 * */
export const formatTimer = (duration) => {
  const seconds = pad(duration % 60);
  const minutes = pad(parseInt(duration / 60, 10));

  return `${minutes}:${seconds}`;
};

/** Get default audio record file name
 * @return {string} - Returns file name
 * */
export const getDefaultAudioRecordFileName = () => {
  const currentDate = new Date();
  const month = (currentDate.getMonth() < 10 ? '0' : '') + Number(currentDate.getMonth() + 1);
  const day = (currentDate.getDate() < 10 ? '0' : '') + currentDate.getDate();
  const minutes = (currentDate.getMinutes() < 10 ? '0' : '') + currentDate.getMinutes();
  const hours = (currentDate.getHours() < 10 ? '0' : '') + currentDate.getHours();
  const seconds = (currentDate.getSeconds() < 10 ? '0' : '') + currentDate.getSeconds();
  return `${currentDate.getFullYear()}-${month}-${day}-${hours}${minutes}${seconds}`;
};

/** Get default audio record file from blob
 * @param {object} recordBlob - The record blob.
 * @return {object} - Returns file object
 * */
export const getRecordFile = recordBlob => (new File([recordBlob], `${getDefaultAudioRecordFileName()}.wav`, { type: "image/wav" }));// eslint-disable-line



// WEBPACK FOOTER //
// ./src/messages/helpers/recorder.helpers.js